import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { User } from "../../types/types";


const initialState: {user: User | undefined} = {
    user:  undefined
}

export const authenticate = createAsyncThunk('authenticate', async (token: string) =>{
    try{
        const responce = await axios.get('https://api.escuelajs.co/api/v1/auth/profile', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        })
        return responce.data
    } catch(e){
        console.log(e)
    }
})

const auth = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuth: (state, action: PayloadAction<User>) => {state.user = action.payload},
        logout: (state) => {
            state['user'] = undefined
            localStorage.removeItem('webToken')
        }
    },
    extraReducers: (build) => {
        build
        .addCase(authenticate.fulfilled, (state, action: PayloadAction<User>) => {
            return {user: action.payload}
        })
    }
})

export const authReducer = auth.reducer
export const {setAuth, logout} = auth.actions